module.exports = __webpack_public_path__ + "static/media/customer3.9dac5586.svg";